<template>
  <div class="paper_category">
    <div class="paper_category_list mt-20 flex Flexalign">
      <div class="paper_category_list_one p-10" v-for="(item, index) in currentDisplayList" :key="index"
        :class="[index % 3 != 0 ? 'ml-15' : '']">
        <div class="paper_category_list_one_top p-10" :class="[
          index % 3 == 1
            ? 'paper_category_list_one_top_green'
            : index % 3 == 2
              ? 'paper_category_list_one_top_orange'
              : '',
        ]">
          <div class="category_name">{{ item.categoryName }}</div>
          <div class="category_count mt-5 flex Flexalign FlexBetween">
            <div class="flex">
              <div>试卷数</div>
              <div class="ml-10">{{ item.paperNum }}</div>
            </div>
            <div class="flex">
              <div>浏览量</div>
              <div class="ml-10">{{ item.pageViews }}</div>
            </div>
            <div class="flex">
              <div>下载量</div>
              <div class="ml-10">{{ item.downloadNum }}</div>
            </div>
          </div>
        </div>
        <div class="paper_list">
          <div class="paper_one mt-10 flex FlexBetween Flexalign" v-for="(sitem, sindex) in item.paperList"
            :key="sindex" @click="viewExamPaper(sitem)">
            <el-image class="test_paper_cover_icon" :src="iconPath('test_paper_cover_icon.svg')"></el-image>
            <div class="paper_info flex flexcolumn FlexBetween flex-1 ml-5">
              <div class="paper_name toverflows toverflow2">{{ sitem.paperDocumentName }}</div>
              <div class="flex Flexalign FlexBetween paper_count">
                <div class="flex">
                  <div>浏览量</div>
                  <div class="ml-10">{{ sitem.viewCount }}</div>
                </div>
                <div class="flex">
                  <div>下载量</div>
                  <div class="ml-10">{{ sitem.downloadCount }}</div>
                </div>
                <div class="flex">
                  <div class="">{{ $Moment(sitem.createTime).format("MM-DD") }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 左侧按钮，添加点击事件和禁用状态 -->
    <el-image class="paper_left_remove_icon cursor_pointer" :src="iconPath('paper_left_remove_icon.png')"
      :class="{ disabled: currentPage === 0 }" @click="prevPage">
    </el-image>

    <!-- 右侧按钮，添加点击事件和禁用状态 -->
    <el-image class="paper_left_remove_icon cursor_pointer paper_right_remove_icon"
      :src="iconPath('paper_right_remove_icon.png')" :class="{ disabled: currentPage >= maxPage }" @click="nextPage">
    </el-image>
  </div>
</template>

<script>
export default {
  name: "GjkcH5PaperCategory",

  data() {
    return {
      currentPage: 0, // 当前页码
      itemsPerPage: 3, // 每页显示的项目数
      paperCategoryList: [],
    };
  },

  computed: {
    // 计算最大页码
    maxPage() {
      return Math.ceil(this.paperCategoryList.length / this.itemsPerPage) - 1;
    },
    // 计算当前显示的项目列表
    currentDisplayList() {
      const start = this.currentPage * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.paperCategoryList.slice(start, end);
    },
  },

  mounted() {
    console.log("总页数:", this.maxPage + 1);
    this.getExaminationListBySubjects();
  },

  methods: {
    // 上一页
    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
        console.log("切换到上一页，当前页:", this.currentPage);
      }
    },
    // 下一页
    nextPage() {
      if (this.currentPage < this.maxPage) {
        this.currentPage++;
        console.log("切换到下一页，当前页:", this.currentPage);
      }
    },

    // 试卷统计列表
    getExaminationListBySubjects() {
      let listQuery = {
        page: 1,
        pageSize: 3,
        subjectIds: "",
      };
      this.$store.state.filter.subjectList.forEach((item) => {
        listQuery.subjectIds += item.subjectId + ",";
      });
      // 去除最后一个逗号
      if (listQuery.subjectIds.length > 0) {
        listQuery.subjectIds = listQuery.subjectIds.substring(
          0,
          listQuery.subjectIds.length - 1
        );
      }
      this.$Api.examination
        .getExaminationListBySubjects(listQuery)
        .then((res) => {
          let examList = res.data.data;
          this.getExaminationListInfoBySubjects(examList, listQuery.subjectIds);
        })
        .catch(() => { });
    },
    // 试卷各学科统计
    getExaminationListInfoBySubjects(examList, subjectIds) {
      this.$Api.examination
        .getExaminationListInfoBySubjects(subjectIds)
        .then((res) => {
          let result = res.data.data;
          let arr = [];
          examList.forEach((item, index) => {
            if (item.length) {
              let subjectInfo = this.$store.state.filter.subjectList.filter(sitem => sitem.subjectId == item[0].subjectId)[0];
              let countInfo = result[index];
              arr.push({
                categoryName: subjectInfo.subjectName,
                paperNum: countInfo.totalCount,
                pageViews: countInfo.viewCount,
                downloadNum: countInfo.downloadCount,
                paperList: item
              })
            }
          });
          this.paperCategoryList = arr;
        })
        .catch(() => { });
    },
    // 查看试卷
    viewExamPaper(info) {
      this.href("/examPaperView", { paperDocumentId: info.paperDocumentId })
    }
  },
};
</script>

<style lang="scss" scoped>
.paper_category {
  width: $pageMainWidth;
  position: relative;

  .paper_left_remove_icon {
    position: absolute;
    left: -100px;
    top: 160px;
    width: 80px;
    height: 80px;

    // 禁用状态样式
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      filter: grayscale(100%);
    }
  }

  .paper_right_remove_icon {
    left: auto;
    right: -100px;
  }

  .paper_category_list {
    overflow-x: hidden;

    .paper_category_list_one {
      width: 390px;
      height: 364px;
      background: #ffffff;
      border-radius: 12px;
      flex-shrink: inherit;
      box-sizing: border-box;

      .paper_category_list_one_top {
        height: 83px;
        background: linear-gradient(180deg, #ffeaea 0%, #ffffff 100%);
        border-radius: 12px 12px 0px 0px;
        color: #ff807f;
        box-sizing: border-box;
        font-size: 14px;
        border-bottom: 1px solid;
        border-image: linear-gradient(45deg,
            rgba(0, 0, 0, 0),
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0)) 1 1;

        .category_name {
          font-size: 22px;
        }
      }

      .paper_category_list_one_top_green {
        background: linear-gradient(180deg, #f1fffc 0%, #ffffff 100%);
        color: #13d6aa;
      }

      .paper_category_list_one_top_orange {
        background: linear-gradient(180deg, #fff0e2 0%, #ffffff 100%);
        color: #ffa350;
      }

      .paper_list {
        .paper_one {
          .test_paper_cover_icon {
            width: 64px;
            height: 75px;
          }

          .paper_info {
            height: 65px;

            .paper_name {
              font-size: 14px;
              color: #303030;
            }

            .paper_count {
              font-size: 12px;
              color: #909090;
            }
          }
        }
      }
    }
  }
}
</style>
